import { isUndefinedOrNull } from "@omnia/shared/utils/utils";
import { HoldingData, HoldingValidationMessage } from "./types";


/** Validates the holding data (state) and returns array of error messages associated with properties names. If the result array is not empty, the holding data (state) is invalid. */
export const validateHoldingData = (data: HoldingData, isSessionSetUp: boolean): HoldingValidationMessage[] => {
    const result: HoldingValidationMessage[] = []
    if (!data) result.push({ propertyName: '_global', msg: `State object is undefined.`});

    if ((data?.holdingTradingName?.trim().length ?? 0) === 0)
        result.push({ propertyName: 'holdingTradingName', msg: `Trading Name is required.`});

    if (data?.enablePostTown && !data?.town) 
        result.push({ propertyName: 'town', msg: `Post Town is required.`});

    if (data?.regions && !data?.region) 
        result.push({ propertyName: 'region', msg: `Region is required.`});

    if ((data?.totalArea ?? 0) < 0)
        result.push({ propertyName: 'totalArea', msg: `Total area cannot be less than zero.`});

    if (data?.grasslandDerogation && !data?.grasslandDerogationNumber) 
        result.push({ propertyName: 'grasslandDerogationNumber', msg: `Grassland Derogation Number is required.`});

    if (!data?.firstCroppingYear) 
        result.push({ propertyName: 'firstCroppingYear', msg: `Starting Year is required.`});

    if (!data?.pkModel) 
        result.push({ propertyName: 'pkModel', msg: `PK model is required.`});

    if (!data?.customWeather && !data?.station && isSessionSetUp ) 
        result.push({ propertyName: 'station', msg: `Weather station is required.`});

    if (data?.customWeather) {
        for (let idx = 1; idx <= 12; idx++) {
            const mth = data?.weatherData?.find(x => x.Month == idx);
            if (isUndefinedOrNull(mth?.Rainfall) || mth.Rainfall < 0) {
                result.push({ propertyName: `rainfall${mth.Month}`, msg: `PK model is required.`});
            }
        }
    }

    return result;
}

/** Returns true if no message is found for the given property name. */
export const isHoldingValid = (propertyName: string, data: HoldingData) => {
    return (data?.validationMessages?.find(x => x.propertyName === propertyName)?.msg.length ?? 0) === 0;
}